import React from "react";
import { selectUserInfo } from "../../../features/userInfo/userInfoSlice";
import { useSelector } from "react-redux";
import ReferedByFriend from "./ReferedByFriend";
import InviteFriend from "./InviteFriend";
import useMediaQuery from '@material-ui/core/useMediaQuery';
import colors from "../../colors";
import { texts } from "../../general/texts";
import { useNavigate } from "react-router-dom";

const GeneralView = () => {
    const userInfo = useSelector(selectUserInfo)
    const isSmallScreen = useMediaQuery('(max-width:600px)');
    const navigate = useNavigate()

    return (
        <>
            {(userInfo.isUserInvited && !userInfo.canUserGenerateCode) ? (
                <ReferedByFriend />
            ) : (
                <InviteFriend />
            )}
            <div style={{ justifyContent: 'right', marginTop: '80px', marginRight: isSmallScreen ? '10px' : '350px', display: 'flex', flexDirection: 'row' }}>
                <span onClick={() => navigate('/inviteFriend/howItWorks')} style={{ color: colors.orange, fontWeight: 700, fontSize: '15px', cursor: 'pointer' }}>{texts['prompt-how-it-works']}</span>
                <span><a href="https://easypay.al/wp-content/uploads/2024/11/Marreveshje%20e%20Programit%20Refero-nj%C3%AB-mik.pdf" target="_blank" style={{ marginLeft: '40px', color: colors.orange, fontSize: '15px', fontWeight: 700, textDecoration: 'none' }}>{texts['title-terms-and-conditions']}</a></span>
            </div>
        </>
    )
}
export default GeneralView;